import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

interface Question {
  id: number;
  type: string;
  title: string;
  required: boolean;
  options?: string[];
  minRating?: number;
  maxRating?: number;
  acceptedFileTypes?: string;
}

@Component({
  selector: 'app-questionarise',
  templateUrl: './questionarise.component.html',
  styleUrls: ['./questionarise.component.scss']
})
export class QuestionariseComponent {

  questions: Question[] = [];
  questionCounter = 0;
  selectedType = 'subjective';

  addQuestion(): void {
    const type = this.selectedType;
    this.questionCounter++;

    const question: Question = {
      id: this.questionCounter,
      type,
      title: '',
      required: false,
      options: (type === 'checklist' || type === 'radio') ? ['Option 1', 'Option 2'] : [],
      minRating: type === 'rating' ? 1 : undefined,
      maxRating: type === 'rating' ? 5 : undefined,
      acceptedFileTypes: type === 'file' ? '.jpg,.png,.pdf,.doc' : undefined,
    };

    this.questions.push(question);
  }

  removeQuestion(id: number): void {
    this.questions = this.questions.filter(q => q.id !== id);
  }

  addOption(question: Question): void {
    if (question.options) {
      question.options.push(`Option ${question.options.length + 1}`);
    }
  }

  removeOption(question: Question, index: number): void {
    if (question.options && question.options.length > 1) {
      question.options.splice(index, 1);
    }
  }

  clearAll(): void {
    if (confirm('Are you sure you want to clear all questions?')) {
      this.questions = [];
      this.questionCounter = 0;
    }
  }

  exportJSON(): void {
    const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(this.questions, null, 2));
    const a = document.createElement('a');
    a.setAttribute("href", dataStr);
    a.setAttribute("download", "questions.json");
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
}